import type { LanguageCode } from '@ampshift/shared';
import { createApiClient } from './client';
import { authStore, getAuthHeaders, signOutLocally } from '../auth/store';
import { ensureFreshIdToken } from '../auth/cognito';
import { localSettingsStore, uiLanguageToLocale } from '../settings/local';

export { ApiError, createApiClient, type ApiClient } from './client';

function currentLocale(): LanguageCode {
  const s = localSettingsStore.get();
  return uiLanguageToLocale(s.uiLanguage, s.inputLanguage === 'auto' ? 'ar-AE' : s.inputLanguage);
}

/** The app-wide client: Cognito/dev headers, tab session id, locale, and sign-out on unrecoverable 401. */
export const api = createApiClient({
  baseUrl: import.meta.env.VITE_API_BASE ?? '',
  getAuthHeaders: async () => {
    await ensureFreshIdToken();
    return getAuthHeaders(authStore.get());
  },
  getLocale: currentLocale,
  tryRefresh: async () => {
    const state = authStore.get();
    if (state.status !== 'cognito') return false;
    const token = await ensureFreshIdToken(Number.MAX_SAFE_INTEGER);
    return Boolean(token && token !== state.idToken);
  },
  onUnauthorized: () => {
    if (authStore.get().status !== 'signedOut') signOutLocally('expired');
  },
});
